import { getUmbracoContent } from 'application/adapters/umbraco/umbracoAdapter';

interface GetNavigationParams {
	host: string | string[];
	preview?: boolean;
	accessToken?: string;
	previewData?: Models.PreviewData;
}

export interface NavigationResponse {
	navigationRoot: {
		name: string;
		header: Array<Umbraco.HomePage & { children?: Umbraco.HomePage[] }>;
	};
}

export const getNavigation = async ({ host, preview, accessToken, previewData }: GetNavigationParams): Promise<NavigationResponse> => {
	const query = `{
		navigationRoot: page(path: "/") {
			name
			header: children {
				name
				url
				id
				properties(fields: ["pageSettings", "title"])
				children {
					name
					url
					id
					properties(fields: ["pageSettings", "title"])
				}
			}
		}
	}`;
	return await getUmbracoContent({
		host,
		query,
		method: 'POST',
		preview,
		previewData,
		url: '/',
		accessToken: accessToken,
	});
};

export interface NavigationRepositoryInterface {
	getNavItems(currentPageId?: number): Models.NavGroupItem[];
}

export const NavigationRepositoryFactory = (navigation: NavigationResponse): NavigationRepositoryInterface => ({
	getNavItems: (currentPageId?: number): Models.NavGroupItem[] =>
		navigation?.navigationRoot?.header?.reduce<Models.NavGroupItem[]>((filtered, headerItem) => {
			const navSetting = headerItem.properties.pageSettings?.find((s) => s.documentType === 'navigation');

			if (navSetting?.content.properties.umbracoNaviHide) return filtered;

			const { navigationTitle } = navSetting?.content?.properties ?? {};

			const children: Models.NavigationItem[] =
				headerItem.children?.reduce<Models.NavigationItem[]>((childFiltered, childItem) => {
					const childNavSetting = childItem.properties.pageSettings?.find((s) => s.documentType === 'navigation');

					if (childNavSetting?.content.properties.umbracoNaviHide) return childFiltered;

					const { navigationTitle: childNavTitle } = childNavSetting?.content?.properties ?? {};
					childFiltered.push({
						id: childItem?.id,
						title: childNavTitle ? childNavTitle : childItem.name,
						url: childItem?.url,
						state: currentPageId === childItem?.id ? 'isActive' : '',
					});
					return childFiltered;
				}, []) ?? [];

			filtered.push({
				id: headerItem?.id,
				title: navigationTitle ? navigationTitle : headerItem.name,
				url: headerItem?.url,
				children: children.length > 0 ? children : undefined,
			});

			return filtered;
		}, []) ?? [],

});
